import { ISharedDocumentDeleteProps } from "./interface"
import { Modal, Button } from "antd"
import { useTranslation } from "react-i18next"

const SharedDocumentDelete = ({ title, isOpen, confirmQuestion, loading, onCloseDeleteDialog, onYesButtonClick }: ISharedDocumentDeleteProps) => {
    const { t } = useTranslation()
    return (
        <Modal 
            visible={isOpen}
            closable={false}
            footer={null}
            centered
            mask
            maskClosable
            onCancel={onCloseDeleteDialog}
        >
            { /* Header */ }
            {title && <p className="font-weight-700 font-20 mt-2 mb-2 mx-auto text-center">{title}</p>}

            {/* Confirm Question */}
            <p className="text-center my-1 mb-4">{confirmQuestion}</p>

            {/* Button */}
            <div className="flex flex-row justify-center space-x-4">
                <Button 
                    danger 
                    type="primary" 
                    style={{
                        borderRadius: "5px"
                    }} 
                    onClick={onYesButtonClick}
                    loading={loading}
                >{t('myDocument.deleteDialog.yesButton')}</Button>
                <Button 
                    style={{
                        borderRadius: "5px"
                    }} 
                    onClick={onCloseDeleteDialog} 
                >{t('myDocument.deleteDialog.noButton')}</Button>
            </div>
        </Modal>
    )

}

export { SharedDocumentDelete }